import styles from './review_item.module.scss';
import {Maybe, ReviewContentType, ReviewListType} from '../../../gql/pwa/graphql.ts';
import {Card} from '../../../components/card/card.tsx';
import {__} from '../../../support/lang/translations.ts';
import {classNames} from '../../../support/classnames.ts';
import {FlexColumn} from '../../../components/utility/flex_column.tsx';
import {FlexRow} from '../../../components/utility/flex_row.tsx';
import {Stars} from './stars.tsx';
import {Spacer} from '../../../components/utility/spacer.tsx';

interface OwnProps {
    review?: ReviewListType | null;
}

interface ReviewContentProps {
    reviewContent?: Maybe<Maybe<ReviewContentType>[]> | undefined;
}

function ReviewContent({reviewContent}: ReviewContentProps) {
    if (reviewContent == null) {
        return;
    }

    let title = reviewContent[1]?.answer ?? '';
    let description = reviewContent[2]?.answer ?? null;
    let recommend = reviewContent[3]?.answer?.toString().toLowerCase() === 'ja' ?? false;
    let stars: Maybe<ReviewContentType>[] = [reviewContent[0]];

    // LEGACY Review Type
    if (reviewContent.length === 8) {
        title = reviewContent[7]?.answer ?? '';
        description = null;
        recommend = reviewContent[0]?.answer?.toString().toLowerCase() === 'ja' ?? false;
        stars = [reviewContent[1], reviewContent[2], reviewContent[3], reviewContent[4]];
    }

    return (
        <div
            className={classNames(styles.review_item_content, {
                [styles.recommend]: recommend,
            })}
        >
            <strong>{title}</strong>
            {description && <span>{description}</span>}

            <Spacer />
            {stars && stars.length !== 0 && (
                <FlexColumn>
                    {stars
                        .filter((star) => star != null)
                        .map((star, index) => (
                            <FlexRow key={index}>
                                <FlexColumn>
                                    <strong>{star?.question}</strong>
                                </FlexColumn>
                                <FlexColumn>
                                    <Stars rating={star?.answer ?? 0} />
                                </FlexColumn>
                            </FlexRow>
                        ))}
                </FlexColumn>
            )}

            {recommend && (
                <div className={styles.recommend_item}>
                    <i className="fa-light fa-check"></i>
                    {__('reviews.recommend')}
                </div>
            )}
        </div>
    );
}

export function ReviewItem({review}: OwnProps) {
    return (
        <Card>
            <div className={styles.review_item}>
                <div className={styles.review_item_title}>
                    <h3>
                        {review?.name} {__('reviews.from')} {review?.city}
                    </h3>
                    {review?.reviewDate != null && <h4 className="text-muted">{review?.reviewDate}</h4>}
                    <div
                        className={classNames(
                            styles.review_item_rating,
                            `review_item_rating_${Math.ceil(review?.rating ?? 0)}`,
                        )}
                    >
                        {review?.rating}
                    </div>
                </div>
                <ReviewContent reviewContent={review?.reviewContent} />
            </div>
        </Card>
    );
}
